import React from 'react';
import type { BioComponent } from '../../../types/builder';

interface BioRendererProps {
  component: BioComponent;
}

export const BioRenderer: React.FC<BioRendererProps> = ({ component }) => {
  const { content, fontSize, textColor, backgroundColor, alignment, padding, style } = component.settings;

  const bioStyle = style || 'default';

  // Default Style
  if (bioStyle === 'default') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-3xl mx-auto">
          <p style={{ fontSize: `${fontSize}px`, color: textColor, lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
            {content}
          </p>
        </div>
      </div>
    );
  }

  // Modern Style
  if (bioStyle === 'modern') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-3xl mx-auto">
          <div className="bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg p-6 border-l-4 border-purple-600">
            <p style={{ fontSize: `${fontSize}px`, color: textColor, lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
              {content}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Minimal Style
  if (bioStyle === 'minimal') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-2xl mx-auto">
          <p style={{ fontSize: `${fontSize}px`, color: textColor, lineHeight: '1.5', whiteSpace: 'pre-wrap', fontWeight: '300' }}>
            {content}
          </p>
        </div>
      </div>
    );
  }

  // Quote Style
  if (bioStyle === 'quote') {
    return (
      <div style={{ backgroundColor, padding: `${padding}px`, textAlign: alignment }}>
        <div className="max-w-3xl mx-auto">
          <blockquote className="relative">
            <div className="absolute -top-4 -left-2 text-6xl text-gray-300 font-serif">"</div>
            <p 
              style={{ 
                fontSize: `${fontSize}px`, 
                color: textColor, 
                lineHeight: '1.6', 
                whiteSpace: 'pre-wrap',
                fontStyle: 'italic',
                paddingLeft: '40px'
              }}
            >
              {content}
            </p>
            <div className="absolute -bottom-8 right-0 text-6xl text-gray-300 font-serif">"</div>
          </blockquote>
        </div>
      </div>
    );
  }

  return null;
};

